import { render, staticRenderFns } from "./ga_base_data.vue?vue&type=template&id=4300aac6&scoped=true"
import script from "./ga_base_data.vue?vue&type=script&lang=js"
export * from "./ga_base_data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4300aac6",
  null
  
)

export default component.exports